import { PrayerStreamApi } from '@ccm-innovation/member-center-bff-sdk-axios';
import axios from 'axios';
import { ContainerInstance, Service } from 'typedi';
import { type AppEnvironment } from '../config/app-environment';
import { EnvironmentService } from '../config/environment.service';
import { HttpHeader } from '../constants';

@Service()
export class PrayerStreamApiService {
  readonly prayerStreamApi: PrayerStreamApi;

  constructor(container: ContainerInstance) {
    const { environment } = container.get(EnvironmentService<AppEnvironment>);
    const axiosInstance = axios.create({
      headers: {
        [HttpHeader.AccessControlAllowOrigin]: '*',
      },
    });

    this.prayerStreamApi = new PrayerStreamApi(
      undefined,
      environment.VITE_APP_PRAYER_STREAM_BFF_URL,
      axiosInstance,
    );
  }
}
